"use client"

import { Rocket, Users, Zap, Brain } from "lucide-react"
import { motion } from "framer-motion"
import { Link } from "react-router-dom"

const Services = () => {
  return (
    <div className="w-full relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 rounded-full blur-3xl animate-pulse delay-1000" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full" />
      </div>

      {/* Grid pattern overlay */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:50px_50px]" />

      {/* <div className="relative z-10 container mx-auto px-8 md:px-20 py-16 md:py-8">
      
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        
          <motion.div
            className="flex justify-center  lg:text-left order-1 lg:order-2"
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
          >
            <div className="relative">
            
              <svg
                width="300"
                height="300"
                viewBox="0 0 400 400"
                className="w-full max-w-md lg:max-w-lg"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
               
                <motion.circle
                  cx="200"
                  cy="200"
                  r="180"
                  fill="url(#gradient1)"
                  opacity="0.1"
                  animate={{ scale: [1, 1.05, 1] }}
                  transition={{ duration: 4, repeat: Number.POSITIVE_INFINITY }}
                />

               
                <motion.rect
                  x="120"
                  y="140"
                  width="160"
                  height="120"
                  rx="12"
                  fill="url(#gradient2)"
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ delay: 0.5, duration: 0.8 }}
                />

              
                <motion.rect
                  x="140"
                  y="160"
                  width="80"
                  height="4"
                  rx="2"
                  fill="#8B5CF6"
                  animate={{ opacity: [0.5, 1, 0.5] }}
                  transition={{ duration: 2, repeat: Number.POSITIVE_INFINITY }}
                />
                <motion.rect
                  x="140"
                  y="170"
                  width="60"
                  height="4"
                  rx="2"
                  fill="#06B6D4"
                  animate={{ opacity: [0.5, 1, 0.5] }}
                  transition={{ duration: 2, repeat: Number.POSITIVE_INFINITY, delay: 0.3 }}
                />
                <motion.rect
                  x="140"
                  y="180"
                  width="100"
                  height="4"
                  rx="2"
                  fill="#8B5CF6"
                  animate={{ opacity: [0.5, 1, 0.5] }}
                  transition={{ duration: 2, repeat: Number.POSITIVE_INFINITY, delay: 0.6 }}
                />

              
                <motion.g
                  animate={{ rotate: 360 }}
                  transition={{ duration: 20, repeat: Number.POSITIVE_INFINITY, ease: "linear" }}
                >
                
                  <motion.circle cx="80" cy="120" r="20" fill="url(#gradient3)" opacity="0.8" />
                  <motion.path
                    d="M75 115 L85 115 L85 125 L75 125 Z M80 110 L80 130 M70 120 L90 120"
                    stroke="#fff"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />

                
                  <motion.circle cx="320" cy="280" r="20" fill="url(#gradient4)" opacity="0.8" />
                  <foreignObject x="308" y="268" width="24" height="24">
                    <Rocket className="w-6 h-6 text-white" />
                  </foreignObject>

               
                  <motion.circle cx="100" cy="300" r="20" fill="url(#gradient5)" opacity="0.8" />
                  <foreignObject x="88" y="288" width="24" height="24">
                    <Brain className="w-6 h-6 text-white" />
                  </foreignObject>

              
                  <motion.circle cx="300" cy="100" r="20" fill="url(#gradient6)" opacity="0.8" />
                  <foreignObject x="288" y="88" width="24" height="24">
                    <Zap className="w-6 h-6 text-white" />
                  </foreignObject>
                </motion.g>

              
                <motion.path
                  d="M100 140 Q150 100 200 140"
                  stroke="url(#gradient7)"
                  strokeWidth="2"
                  fill="none"
                  strokeDasharray="5,5"
                  animate={{ strokeDashoffset: [0, -10] }}
                  transition={{ duration: 2, repeat: Number.POSITIVE_INFINITY, ease: "linear" }}
                />
                <motion.path
                  d="M280 160 Q250 200 200 240"
                  stroke="url(#gradient7)"
                  strokeWidth="2"
                  fill="none"
                  strokeDasharray="5,5"
                  animate={{ strokeDashoffset: [0, -10] }}
                  transition={{ duration: 2, repeat: Number.POSITIVE_INFINITY, ease: "linear", delay: 1 }}
                />

              
                <defs>
                  <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#8B5CF6" />
                    <stop offset="100%" stopColor="#06B6D4" />
                  </linearGradient>
                  <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#1F2937" />
                    <stop offset="100%" stopColor="#374151" />
                  </linearGradient>
                  <linearGradient id="gradient3" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#F59E0B" />
                    <stop offset="100%" stopColor="#D97706" />
                  </linearGradient>
                  <linearGradient id="gradient4" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#EF4444" />
                    <stop offset="100%" stopColor="#DC2626" />
                  </linearGradient>
                  <linearGradient id="gradient5" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#8B5CF6" />
                    <stop offset="100%" stopColor="#7C3AED" />
                  </linearGradient>
                  <linearGradient id="gradient6" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#06B6D4" />
                    <stop offset="100%" stopColor="#0891B2" />
                  </linearGradient>
                  <linearGradient id="gradient7" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#8B5CF6" stopOpacity="0.6" />
                    <stop offset="100%" stopColor="#06B6D4" stopOpacity="0.6" />
                  </linearGradient>
                </defs>
              </svg>

           
              {Array.from({ length: 6 }, (_, i) => (
                <motion.div
                  key={i}
                  className="absolute w-2 h-2 rounded-full"
                  style={{
                    top: `${20 + i * 15}%`,
                    left: `${10 + (i % 2) * 80}%`,
                  }}
                  animate={{
                    y: [-10, 10, -10],
                    opacity: [0.3, 1, 0.3],
                  }}
                  transition={{
                    duration: 3,
                    repeat: Number.POSITIVE_INFINITY,
                    delay: i * 0.5,
                  }}
                />
              ))}
            </div>
          </motion.div>

        
          <motion.div
            className="text-center lg:text-left order-1 lg:order-1"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.4 }}
          >
            <motion.h2
              className="text-2xl md:text-4xl lg:text-4xl font-bold mb-6 bg-clip-text text-black bg-gradient-to-r from-white via-purple-200 to-cyan-200"
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.6, duration: 0.8 }}
            >
              Tech{" "}
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-purple-400 via-pink-400 to-cyan-400 animate-pulse">
                Support
              </span>
            </motion.h2>

            <motion.p
              className="text-sm sm:text-base leading-relaxed mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8, duration: 0.8 }}
            >
              
              Acting as a Trusted Intermediary we support startups in finding the right service providers who deliver results right on time leading to their growth additionally safeguarding them from scams and fake quotes
            </motion.p>

            <ul className="flex flex-col sm:flex-row gap-4 mb-8">
              <li className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-purple-50 text-purple-700 font-medium text-sm shadow-sm border border-purple-100">
                <span className="w-2 h-2 rounded-full bg-purple-400 inline-block" /> No hidden fees
              </li>
              <li className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-cyan-50 text-cyan-700 font-medium text-sm shadow-sm border border-cyan-100">
                <span className="w-2 h-2 rounded-full bg-cyan-400 inline-block" /> No commissions
              </li>
              <li className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-pink-50 text-pink-700 font-medium text-sm shadow-sm border border-pink-100">
                <span className="w-2 h-2 rounded-full bg-pink-400 inline-block" /> Dependable support
              </li>
            </ul>

           
            <motion.div
              className="flex justify-center lg:justify-start"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 1.2, duration: 0.6 }}
            >
              <Link to="/solutions">
                <motion.button
                  className="inline-flex items-center gap-2 bg-[#020c1b] hover:bg-[#0d1a2e] text-white text-sm md:text-base font-semibold py-2 px-6 rounded-full transition duration-200"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                 Avail Support
                </motion.button>
              </Link>
            </motion.div>

        
          </motion.div>
        </div>

      
      </div> */}
    </div>
  )
}

export default Services
